import React from 'react'
import { Button, DialogOverlay, DialogOverlayActions, List, ListItem, Paragraph } from '@fs/zion-ui'
import { NoticeBullet } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

const PrimaryPersonInfoOverlay = ({ overlay }) => {
  const [t] = useTranslation()
  return (
    <DialogOverlay
      isOpen={overlay.isOpen}
      close={overlay.close}
      size="md"
      title={t('essentialInformationForm.primaryPerson.notSureTitle', 'Who is considered a primary person?')}
      closeLabel={t('essentialInformationForm.primaryPerson.notSureClose', 'Close')}
      footer={
        <DialogOverlayActions>
          <Button emphasis="high" onClick={overlay.close} data-testid="primary-person-not-sure-ok">
            {t('essentialInformationForm.primaryPerson.notSureOk', 'OK')}
          </Button>
        </DialogOverlayActions>
      }
    >
      <Paragraph size="sm">
        {t(
          'essentialInformationForm.primaryPerson.notSureBody',
          'A primary person is the main person a document is about. Typically, there will be just one primary person per record.'
        )}
      </Paragraph>
      <Paragraph size="sm">
        <strong>{t('essentialInformationForm.primaryPerson.notSureExamples', 'Examples')}</strong>
      </Paragraph>
      <Paragraph size="sm">
        {t(
          'essentialInformationForm.primaryPerson.notSurePrimaryList',
          'The following would be considered primary people:'
        )}
      </Paragraph>
      <List>
        <ListItem
          primaryText={t('essentialInformationForm.primaryPerson.notSureExample1', 'The child in a birth record')}
          startElement={<ListItem.Icon Icon={NoticeBullet} />}
          dense
        />
        <ListItem
          primaryText={t(
            'essentialInformationForm.primaryPerson.notSureExample2',
            'The bride and groom in a marriage record'
          )}
          startElement={<ListItem.Icon Icon={NoticeBullet} />}
          dense
        />
        <ListItem
          primaryText={t('essentialInformationForm.primaryPerson.notSureExample3', 'The deceased in an obituary')}
          startElement={<ListItem.Icon Icon={NoticeBullet} />}
          dense
        />
      </List>
      <Paragraph size="sm">
        {t(
          'essentialInformationForm.primaryPerson.notSureNonPrimary',
          'However, a witness or any relative in the above records would not be considered a primary person.'
        )}
      </Paragraph>
    </DialogOverlay>
  )
}

export default PrimaryPersonInfoOverlay
